<template>
    <div>
        <div v-if="isLoading" class="d-flex justify-content-center h-100 align-items-center">
            <b-spinner class="align-middle" variant="secondary" />
        </div>
        <div v-else>
            <div class="mb-4">
                <search-field
                    :placeholder="trans('community.search_users_posts')"
                    :value="this.$route.query.search"
                    @onFormSubmit="onSearchSubmited"
                />
            </div>
            <radio-filter
                v-if="!hasClosedCommunity"
                :label="trans('community.audience')"
                :options=audience
                @onFitlerSelect="onAudienceSelect"
                :selectedItem="this.$route.query.audience"
            />
            <text-filter
                :label="trans('community.people_more_active')"
                :options=filters.topPosters
                @onFitlerSelect="profileFilter"
            />
            <text-filter
                :label="trans('community.contents_more_commented')"
                :options=filters.topComments
                @onFitlerSelect="onFitlerSelected"
            />

            <label class="h6">{{trans('community.order_by')}}</label>
            <b-select
                @change="onOrderByChange"
                v-model="orderByValue"
                class="custom-select"
                :options="options"
                html-field="name"
            />


            <b-modal
                id="check-post-modal"
                header-class="no-border"
                centered
                hide-footer
                ref="check-post-modal"
                size="lg"
            >
                <template v-slot:modal-header="{ close }">
                    <p class="text-primary text-bold"></p>
                    <b-icon icon="x" v-on:click="close()" scale="2" class="close-button" variant="primary"></b-icon>
                </template>
                <div class="row">
                    <div class="col-12 pb-3" v-if="mostCommentPost">
                        <post-card
                            :key="mostCommentPost.id"
                            :poster-id="mostCommentPost.user_id"
                            :is-user-mostCommentPost="mostCommentPost.can_edit === 1 ? true : false"
                            :display-name="mostCommentPost.display_name"
                            :date="mostCommentPost.created_at"
                            :description="mostCommentPost.title"
                            :title="mostCommentPost.description"
                            :post-id="mostCommentPost.id"
                            :reaction="mostCommentPost.reaction"
                            :likes="mostCommentPost.likes"
                            :color="mostCommentPost.color"
                            hasComments
                            :commentsLength="mostCommentPost.comments ? mostCommentPost.comments.length : 0"
                            disableSubmition
                        >
                            <template v-slot:translations>
                                <post-translation-container
                                    :post-id="mostCommentPost.id"
                                    :title-locale="mostCommentPost.title_locale"
                                    :description-locale="mostCommentPost.description_locale"
                                />
                            </template>
                            <comments-box
                                :post-id="mostCommentPost.id"
                                :comments="mostCommentPost.comments"
                                disableSubmition
                            />
                        </post-card>
                    </div>
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
    import SearchField from '../../molecules/SearchField'
    import RadioFilter from '../../molecules/filters/RadioFilter'
    import TextFilter from '../../molecules/filters/TextFilter'
    import CommentsBox from '../../molecules/CommentsBox'
    import PostCard from '../../molecules/cards/PostCard'
    import { USER_PUBLIC_PROFILE } from "../../paths.js"
    import PostTranslationContainer from '../../organisms/PostTranslationContainer.vue'
    import {mapGetters} from "vuex";

    export default {
        name: "CommunityPostsFilters",
        components: { SearchField, RadioFilter, TextFilter, CommentsBox, PostCard, PostTranslationContainer },
        props: {
            orderBy: String
        },

        data() {
          return {
            filters: {},
            orderByValue: '',
            mostCommentPost: {},
            isLoading: true
          }
        },

        computed:{
            ...mapGetters({
                hasClosedCommunity: "user/getHasClosedCommunity"
            }),
            audience: function () {
                return [
                    { name: `${this.trans('community.all_posts')}`, id: '0' },
                    { name: `${this.trans('community.my_company')}`, id: '1' }
                ]
            },
            options: function () {
                return [
                    { value: '1', text: `${this.trans('community.more_popular')}` },
                    { value: '2', text: `${this.trans('community.less_popular')}` },
                    { value: '3', text: `${this.trans('community.more_discussed')}` },
                    { value: '4', text: `${this.trans('community.less_discussed')}` },
                    { value: '5', text: `${this.trans('community.more_recent')}` },
                    { value: '6', text: `${this.trans('community.less_recent')}` }
                ]
            }
        },

        methods: {
            onSearchSubmited(value) {
                this.$emit('getPosts', 1, value, true, this.$route.query.audience, this.orderBy);
                this.$router.push({ name: 'community-posts', query: { search: value, audience: this.$route.query.audience, orderBy: this.orderBy } }).catch(() => {});
            },
            onAudienceSelect(value) {
                this.$emit('getPosts', this.currentPage, this.$route.query.search, true, value, this.orderBy);
                this.$router.push({ name: 'community-posts', query: { search: this.$route.query.search, audience: value, orderBy: this.orderBy } }).catch(() => {});
            },
            onOrderByChange(value) {
                this.$emit('getPosts', this.currentPage, this.$route.query.search, true, this.$route.query.audience, value);
                this.$router.push({ name: 'community-posts', query: { search: this.$route.query.search, audience: this.$route.query.audience, orderBy: value } }).catch(() => {});
            },
            onFitlerSelected(value) {
                this.$refs['check-post-modal'].show()

                this.$axios.get(`/api/rest/community/post/${value}`)
                    .then((res)=>{
                        this.mostCommentPost = res.data.data[0]
                    })
                    .catch((e)=>{
                        console.log(e);
                    })
            },
            profileFilter(value) {
                this.$router.push(this.publicProfileRoute(value))
            },
            publicProfileRoute: function(value) {
                return USER_PUBLIC_PROFILE(value)
            },
            getFilters() {
                this.$axios.get('/api/rest/community/getFilters')
                .then((response) => {
                    this.filters = response.data
                    this.isLoading = false
                })
                .catch((e)=>{
                    console.log(e);
                })
            },
        },
        mounted() {
            this.getFilters();
            this.orderByValue = this.orderBy
        }
    }
</script>
